import React from 'react';
import Seo from '../common/Seo';

import CallToAction from "../common/CallToAction";
import Drawer from "../common/Drawer";
import Projects from "../home/Projects";
import PageTitle from "./include/PageTitle";

import { ReactComponent as GraphicsIcon } from "../assets/skills/graphics.svg";
import OtherSkills from "./include/OtherSkills";
import SkillProjects from "./include/Projects";
import Process from "./include/Process";
import Stack from "./include/Stack";

import { routeIds } from "../i18n/routes";
import { useI18n } from "../i18n/I18nContext";
import ProjectQuery from "../model/Projects";

import Unity from "../assets/skills/Unity.png";
import OpenGL from "../assets/skills/OpenGL.png";
import C from "../assets/skills/C.png";
import Cpp from "../assets/skills/C++.png";
import Blender from "../assets/skills/Blender.png";

function Graphics({route}) {
  const { pathFor, t } = useI18n();
  const steps = t("expertise.graphics.steps");
  const projects = ProjectQuery({filter: "graphics"});
  const techs = [
    { name: "Unity", logo: Unity },
    { name: "OpenGL", logo: OpenGL },
    { name: "C", logo: C },
    { name: "C++", logo: Cpp },
    { name: "Blender", logo: Blender }
  ];

  const title = t("expertise.graphics.title");
  const description = t("expertise.graphics.description");

  return [
    <Seo title={title} description={description} />,
    <PageTitle id="developpement-3d" title={t("expertise.graphics.heading")} text={t("expertise.graphics.intro")} logo={<GraphicsIcon />} />,
    <div className="hidden bg-cyan"></div>,
    <Process steps={steps} color="cyan" />,
    <SkillProjects items={projects} color="cyan" />,
    <Stack techs={techs} />,
    <CallToAction id="contact" title={t("expertise.graphics.ctaTitle")} text={t("expertise.graphics.ctaText")} action={t("common.contactUs")} href={pathFor(routeIds.contact)} />,
    <OtherSkills mainSkill="graphics" />,
    <Projects />,
    <Drawer route={route} />
  ];
}

export default Graphics;
